// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformStatuses = {
  online: "オンライン",
  degraded: "低下",
  offline: "オフライン",
  queued: "キュー待ち",
  stopped: "停止済み",
  unknown: "不明",
  unintegrated: "未接続",
  reachable: "到達可能",
} as const;
